import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@material-ui/core';
import VideoLogo from './VideoLogo';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const location = useLocation();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" bgcolor="#F5F6F9">
      {location.pathname !== '/login' && <UserMenu />}

      <Box>
        <Card style={{ maxWidth: '90vw', width: '500px', borderRadius: '8px' }}>
          <CardContent>
            <Box display="flex" flexDirection="column" alignItems="center">
              <VideoLogo />
              <Typography variant="h6" style={{ color: '#4FA5A3' }}>
                Remote Vision
              </Typography>
            </Box>
          </CardContent>

          <Divider variant="middle" />

          <CardContent>
            <Box px={2}>{props.children}</Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default IntroContainer;
